import { Component } from '@angular/core';
import { ContactFormComponent } from '../../shared/components/contact-form/contact-form.component';
import { TeamComponent } from '../../shared/components/team/team.component';
import { OurServicesComponent } from "../../shared/components/our-services/our-services.component";
import { TopUpButtonComponent } from "../top-up-button/top-up-button.component";
import { Newsletter } from '../../shared/components/newsletter/newsletter';

@Component({
    selector: 'app-home',
    imports: [ContactFormComponent, TeamComponent, OurServicesComponent, TopUpButtonComponent, Newsletter],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css',
    standalone: true
})
export default class HomeComponent {

    scrollToContact() {
    const contactSection = document.getElementById('contact-form-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
